export const locale = {
  title: 'Enter your family member’s email to invite them to the Marathon Health Portal',
  email: 'Email',
  placeholder: 'email',
  invite_to_portal: 'Invite to Portal',
  description: 'They will receive an email with steps to complete their registration.',
  success: 'Email submitted. Your family member will receive an email to complete their registration. ',
};
